import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'msisdn'
})
export class MsisdnPipe implements PipeTransform {

  transform(number: string): string {
    let num = '';
    if (!number) {
      return num;
    } else {
      num = '(' + number.slice(0, 3) + ') ' + number.slice(3, 6) + '-' + number.slice(6);
      return num;
    }
  }

}
